import React from "react";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { EditFieldLabel } from "../../../components/edit/EditPageLayout";
import { MAX_POLICY_PDF_MB } from "./policyDocumentUtils";

export default function PolicyPdfUpload({
  files = [],
  onChange,
  onRemove,
  error,
  required = true,
  inputId = "policy-pdf-input",
  label = "PDF Files",
  multiple = false,
}) {
  const fileList = Array.isArray(files) ? files : files ? [files] : [];

  return (
    <div className="policy-pdf-upload">
      <EditFieldLabel required={required}>{label}</EditFieldLabel>
      <label className="edit-image-dropzone" htmlFor={inputId}>
        <CloudUploadOutlinedIcon className="edit-image-dropzone-icon" />
        <span className="edit-image-dropzone-title">
          Click to upload or drag and drop
        </span>
        <span className="edit-image-dropzone-hint">
          PDF only (max {MAX_POLICY_PDF_MB}MB{multiple ? " per file" : ""})
          {multiple ? " — multiple files allowed" : ""}
        </span>
      </label>
      <input
        id={inputId}
        type="file"
        className="edit-image-input"
        accept="application/pdf,.pdf"
        multiple={multiple}
        onChange={onChange}
      />
      {fileList.length > 0 && (
        <ul className="policy-pdf-file-list">
          {fileList.map((file, index) => (
            <li key={`${file.name}-${index}`} className="policy-pdf-file-item">
              <span>{file.name}</span>
              {onRemove && (
                <button
                  type="button"
                  className="policy-pdf-file-remove"
                  onClick={() => onRemove(index)}
                >
                  Remove
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
      {error && <p className="edit-field-error">{error}</p>}
    </div>
  );
}
